import * as type from "../types";

const initialState = {
  list: [],
  userList: [],
  loading: false,
  error: false,
};

const users = (state = initialState, action) => {
  switch (action.type) {
    case type.USER_SEARCH_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.USER_SEARCH_SUCCEEDED:
      return {
        ...state,
        list: action.payload,
        loading: false,
        error: false,
      };
    case type.USER_SEARCH_FAILED:
      return {
        ...state,
        list: [],
        loading: false,
        error: true,
      };
    case type.USER_LOOKUP_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
      };
    case type.USER_LOOKUP_SUCCEEDED:
      return {
        ...state,
        userList: action.payload,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case type.USER_LOOKUP_FAILED:
      return {
        ...state,
        list: [],
        loading: false,
        error: true,
        userList: [],
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

export default users;
